/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BackendConfiguration
 */
export interface BackendConfiguration {
    /**
     * 
     * @type {string}
     * @memberof BackendConfiguration
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof BackendConfiguration
     */
    value?: string;
}

/**
 * Check if a given object implements the BackendConfiguration interface.
 */
export function instanceOfBackendConfiguration(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BackendConfigurationFromJSON(json: any): BackendConfiguration {
    return BackendConfigurationFromJSONTyped(json, false);
}

export function BackendConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): BackendConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function BackendConfigurationToJSON(value?: BackendConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'value': value.value,
    };
}

